import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import moment from 'moment';

function ModalAuthorizationsLog( {handleOpen, isOpen, log}) {

    const doSearchButton = () => { handleOpen(false) }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Log de Envios </DialogTitle>
                <Divider />
                <DialogContent>
                    <table className="table table-striped table-hover" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>Fecha</th>
                                <th>Descripción</th>
                                <th>Mail</th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {log.map((log, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate ">
                                                    <span className="fw-medium">
                                                        {moment(log.date).format('DD/MM/YYYY')}
                                                    </span>
                                                </a>
                                                <small className="text-muted">{moment(log.date).format('HH:mm')}</small>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {log.description === 'sent' && <span className="badge bg-label-info me-1">ENVIADO</span>}
                                        {log.description === 'resent' && <span className="badge bg-label-info me-1">REENVIADO</span>}
                                        {log.description === 'rejected' && <span className="badge bg-label-info me-1">RECHAZADO</span>}
                                    </td>
                                    <td>{log.emails}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-secondary mb-2 d-grid w-100" onClick={doSearchButton}>Cerrar</button>            
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalAuthorizationsLog;